module.exports = __webpack_public_path__ + "media/promo/advent/images/treem-bot-bac79d27789d9f6b1dfad845d3cc6c56.png";